import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { StripeSubscriptionStatus } from '@workspace/data-types';
import { DateTime } from 'luxon';
import { SubscriptionStatusChipComponent } from '../../chips/subscription-status-chip/subscription-status-chip.component';

@Component({
  selector: 'aura-user-subscription-card',
  imports: [DatePipe, MatDividerModule, SubscriptionStatusChipComponent],
  templateUrl: './subscription-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserSubscriptionCardAuraComponent {
  planName = input.required<string>();
  status = input.required<StripeSubscriptionStatus>();
  cancelAtPeriodEnd = input<boolean>(false);
  currentPeriodStart = input.required<string | Date | null | undefined>();
  currentPeriodEnd = input.required<string | Date | null | undefined>();

  private readonly endDateTime = computed(() => {
    const end = this.currentPeriodEnd();
    if (!end) return null;
    const dt =
      typeof end === 'string' ? DateTime.fromISO(end) : end instanceof Date ? DateTime.fromJSDate(end) : null;
    return dt && dt.isValid ? dt.setLocale('fr') : null;
  });

  readonly isExpired = computed(() => {
    const dt = this.endDateTime();
    if (!dt) return false;
    return dt < DateTime.now();
  });

  readonly daysDifference = computed(() => {
    const dt = this.endDateTime();
    if (!dt) return null;
    const diff = dt.diff(DateTime.now(), 'days').days;
    return Math.round(diff);
  });

  readonly isExpiringSoon = computed(() => {
    const diff = this.daysDifference();
    if (diff === null) return false;
    return diff >= 0 && diff <= 7;
  });

  readonly humanizedRelativeEnd = computed(() => {
    const dt = this.endDateTime();
    if (!dt) return null;
    return dt.toRelative();
  });
}
